import { Link, Text } from '@hh.ru/magritte-ui';
import { SPALink } from '@hh.ru/redux-spa-middleware';
import Conversion from 'bloko/blocks/conversion';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import translation from 'src/components/translation';
import { useSelector } from 'src/hooks/useSelector';
import { LEFT_DOUBLE_QUOTE, NON_BREAKING_SPACE, REGULAR_SPACE, RIGHT_DOUBLE_QUOTE } from 'src/utils/constants/symbols';

const TrlKeys = {
    byQuery: 'correctedquery.byquery',
    company: {
        one: 'search.company.found.one',
        many: 'search.company.found.many',
    },
    employers: {
        one: 'main.counter.employers.one',
        some: 'main.counter.employers.some',
        many: 'main.counter.employers.many',
    },
};

const VacancySearchWizardHeader: TranslatedComponent = ({ trls }) => {
    const criteriaText = useSelector((state) => state.vacancySearchResult.criteria?.text) || '';
    const { totalEmployersFound, rootAreaId } = useSelector((state) => state.vacancyWizard);

    return (
        <Text typography="subtitle-1-semibold">
            {trls[TrlKeys.byQuery]}
            {REGULAR_SPACE}
            <span data-qa="wizard-search-name">
                {LEFT_DOUBLE_QUOTE}
                {criteriaText}
                {RIGHT_DOUBLE_QUOTE}
            </span>
            {REGULAR_SPACE}
            <Conversion
                value={totalEmployersFound}
                hasValue={false}
                one={trls[TrlKeys.company.one]}
                some={trls[TrlKeys.company.many]}
                many={trls[TrlKeys.company.many]}
            />
            {NON_BREAKING_SPACE}
            <Link
                typography="subtitle-1-semibold"
                inline
                Element={SPALink}
                to={`/employers_list?query=${criteriaText}&areaId=${rootAreaId}`}
                data-qa="wizard-link-company-list"
            >
                <Conversion
                    value={totalEmployersFound}
                    one={trls[TrlKeys.employers.one]}
                    some={trls[TrlKeys.employers.some]}
                    many={trls[TrlKeys.employers.many]}
                />
            </Link>
        </Text>
    );
};

export default translation(VacancySearchWizardHeader);
